module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutNextSteps":{"heading":"Kam dál?","text":"Váš košík je prázdný, ale nezoufejte! Prohlédněte si naši nabídku oken a dveří a vyberte si ty pravé pro váš domov.","img":"/assets/images/window-cart.webp","imgAlt":"Kam dál?","customProductsLink":"Udělejte si produkt na míru","stockProductsLink":"Chci vidět skladové produkty"}}}')
  delete Component.options._Ctor
}
